// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2sC8x","container":"styles_container__J8po0","title":"styles_title__2ukEl","wrapper":"styles_wrapper__1y3kh","answer":"styles_answer__3-EhD"};